module.exports = {
	"articleTitle1": "A Girl Walks Into, and then Immediately Out of: The Blind Pig ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Blind Pig",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-blind-pig",
	"articleSnippet1": "Mar 28, 2017 ... It was VulfPunk Night at the Blind Pig, and the menu featured cover songs of \nVulfpeck and Daft Punk by four bands, two of which we actually ...",
	"articleSnippet2": "Best Live Music: The Blind Pig . Amelia Cacchione/DAILY. Allie Taylor. Daily Arts \nWriter. Thursday, March 30, 2017 - 11:27pm ...",
	"totalMisc": 1,
	"articleTitle2": "Best Live Music: The Blind Pig ",
	"address": "208 S 1st St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/blindpig.jpg?itok=holxbRdV",
			"author": "Amelia Cacchione",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/galleryies/DSC_8898.jpg?itok=POU_wbEv",
			"author": "Emilie Farrugia",
			"caption": "Detroit native Flint Eastwood performs at the Blind Pig on Thursday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/galleryies/vel.ART_.BandMasq.11.5.15013.JPG?itok=Y4T0wwoO",
			"author": "Virginia Lozano",
			"caption": "Volcano Worshippers Hourfrom performing as Rage Against The Machine at the 7th Annual Halloween Band Masquerade at the Blind Pig on Friday."
		}
	],
	"position": {
		"lat": 42.280218,
		"lng": -83.751342
	},
	"tips": [
		{
			"text": "Some of my favorite concerts have been here. It's a really cool atmosphere.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "#",
	"categories": {
		"livemusic": 1,
		"bestofaa": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/blindpig.json
// module id = 832
// module chunks = 0